export default {
  'our-cause': () => {
    return '/de/uber/unsere-mission';
  },
};
